(() => {
  const tagName = 'fs-pdp-estimate';
  if (!window.customElements || customElements.get(tagName)) return;

  const dayMilliseconds = 24 * 60 * 60 * 1000;
  const karachiClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Karachi',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  function localClock(now) {
    const result = {};
    for (const part of karachiClock.formatToParts(now)) {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
    }
    return result;
  }

  function addCalendarDays(clock, count) {
    return new Date(Date.UTC(clock.year, clock.month - 1, clock.day + count));
  }

  customElements.define(tagName, class extends HTMLElement {
    static get observedAttributes() {
      return ['data-charge'];
    }

    connectedCallback() {
      if (this.estimateConnected) return;
      this.estimateConnected = true;
      this.onEstimateResume = () => {
        if (document.visibilityState !== 'hidden') this.refreshEstimate();
      };
      document.addEventListener('visibilitychange', this.onEstimateResume);
      window.addEventListener('pageshow', this.onEstimateResume);
      this.refreshEstimate();
    }

    disconnectedCallback() {
      this.estimateConnected = false;
      window.clearTimeout(this.estimateTimer);
      document.removeEventListener('visibilitychange', this.onEstimateResume);
      window.removeEventListener('pageshow', this.onEstimateResume);
      this.estimateTimer = null;
      this.onEstimateResume = null;
    }

    attributeChangedCallback() {
      if (this.estimateConnected) this.updateCharge();
    }

    updateCharge() {
      const target = this.querySelector('[data-fs-estimate-charge]');
      if (!target) return;
      const charge = (this.getAttribute('data-charge') || '').trim();
      target.textContent = charge;
      target.hidden = !charge;
    }

    refreshEstimate() {
      if (!this.estimateConnected) return;
      window.clearTimeout(this.estimateTimer);
      const startTarget = this.querySelector('[data-fs-estimate-start]');
      const endTarget = this.querySelector('[data-fs-estimate-end]');
      if (!startTarget || !endTarget) return;

      const now = new Date();
      const clock = localClock(now);
      const start = addCalendarDays(clock, 4);
      const end = addCalendarDays(clock, 5);
      const formatOptions = { timeZone: 'UTC', day: 'numeric', month: 'short' };
      if (start.getUTCFullYear() !== end.getUTCFullYear()) formatOptions.year = 'numeric';
      const dateFormat = new Intl.DateTimeFormat('en-PK', formatOptions);

      for (const [target, date] of [[startTarget, start], [endTarget, end]]) {
        target.textContent = dateFormat.format(date);
        target.setAttribute('datetime', date.toISOString().slice(0, 10));
      }
      this.updateCharge();
      this.hidden = false;

      const elapsedToday = ((clock.hour * 60 + clock.minute) * 60 + clock.second) * 1000 + now.getMilliseconds();
      const untilMidnight = dayMilliseconds - elapsedToday;
      this.estimateTimer = window.setTimeout(() => this.refreshEstimate(), untilMidnight + 50);
    }
  });
})();
